import React, {Fragment, useEffect,} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {
    currentUserInfoSelector,
    isSessionLoadedSelector
} from "../../../../auth/store/auth-user/selectors";
import {
    setScanCongratulationsVisibility, stickerShowCongratulation
} from "../../../store/sticker-show/actions";
import {themesSelector} from '../../../store/dictionaries/selectors';
import StickersComponentsScannerHeader from "../../components/scanner-header";
import Div100vh from "../../../../uq-ui/components/div-100";
import * as styles from "./style.css";
import StickersComponentsCongratulations from "../../components/congratulations";
import {Grid} from "../../components/grid";
import {useHistory, useParams} from "react-router";
import {
    stickerItemSelector,
} from "../../../store/entities/sticker-items/selectors";
import {stickerShowCongratulationSelector} from "../../../store/sticker-show/selectors";
import {GridItem} from "../../components/grid-item";
import {formatAuthorName} from "./helpers";
import {formatDateTime} from "../../../../uq-ui/helpers/datetimeFormatter";
import {StickerFormatEnum} from "../../../domain/enums/StickerFormatEnum";
import Icon from "../../../../icons/Icon";
import UQButton from "../../../../uq-ui/components/button";
import {useSticker} from "../../../store/sticker-show/hooks";
import { isMemorialType } from "../../../store/sticker-show/selectors";
import _ from "lodash";

export function StickerItemGridItem({stickerItemId}: { stickerItemId: string }) {
    const stickerItem = useSelector((state) => stickerItemSelector(state, stickerItemId))
    const themes = useSelector(themesSelector);
    const history = useHistory();

    if (!stickerItem || !stickerItem.configured_date) {
        return <></>
    }
    const name = formatAuthorName(stickerItem.from?.display_name)
    let date = formatDateTime(stickerItem.configured_date);
    if (date) {
        date = date.split(',')[0]
    }
    let url;
    switch (stickerItem.format) {
        case StickerFormatEnum.Audio:
            url = themes.find(x => x.id === stickerItem.template)?.in_list?.source?.src
            break;
        case StickerFormatEnum.Image:
            url = stickerItem.photo?.thumbnail?.source;
            break;
        case StickerFormatEnum.Video:
            url = stickerItem.video?.thumbnail?.source;
            break;

    }

    return (
        <GridItem
            name={name}
            date={date}
            background={[url]}
            id={stickerItemId}
            onClick={() => history.push(`/stickers/${stickerItem.sticker_id}/${stickerItem.id}`)}/>
    );
}

export function StickerItemPreviewItem({stickerItemId}: { stickerItemId: string }) {
    const stickerItem = useSelector((state) => stickerItemSelector(state, stickerItemId))
    const themes = useSelector(themesSelector);
    const history = useHistory();

    if (!stickerItem || !stickerItem.configured_date) {
        return <></>
    }
    let date = formatDateTime(stickerItem.configured_date);
    if (date) {
        date = date.split(',')[0]
    }
    let url;
    switch (stickerItem.format) {
        case StickerFormatEnum.Audio:
            url = themes.find(x => x.id === stickerItem.template)?.in_list?.source?.src
            break;
        case StickerFormatEnum.Image:
            url = stickerItem.photo?.thumbnail?.source;
            break;
        case StickerFormatEnum.Video:
            url = stickerItem.video?.thumbnail?.source;
            break;

    }

    return (
        <div className={styles.stickerItemsPreviewItem} style={{ backgroundImage: 'url("' + url + '")' }} onClick={() => history.push(`/stickers/${stickerItem.sticker_id}/${stickerItem.id}`)}></div>
    );
}


export default function StickerScreensShow(props) {
    const {id: stickerId}: { id: string } = useParams();
    const {t} = useTranslation("scr-show-sticker");
    const stickerScanEvent = useSelector(stickerShowCongratulationSelector);
    const currentUser = useSelector(currentUserInfoSelector);
    const history = useHistory();
    const dispatch = useDispatch();
    const [sticker, stickerItems] = useSticker(stickerId);
    const isSessionLoaded = useSelector(isSessionLoadedSelector);
    const isStickerTypeMemorial = useSelector(isMemorialType);
    isStickerTypeMemorial && props.appThemeChanger('setMemorialTheme');

    const canAddStickerItem =
        (currentUser.id === sticker?.from || !sticker?.from)
        && sticker?.sticker_items_limit
        && stickerItems
        && (stickerItems.length < sticker.sticker_items_limit);

    useEffect(() => {
        if (stickerId && sticker && !sticker.from && stickerItems && stickerItems.length === 0) {
            history.push(`/stickers/${stickerId}/new`);
        }
    }, [stickerId, sticker, stickerItems])

    const showCongratulation = stickerScanEvent && stickerItems && stickerItems.length > 0;
    if (showCongratulation) {
        return (isSessionLoaded
            &&
          <Fragment>
            <StickersComponentsCongratulations
              canAddStickerItem={!!canAddStickerItem}
              containerStyle={{zIndex: 1101}}
              title={t('congratulationsTitle')}
              viewItPressed={() => {
                  if (sticker?.sticker_items_limit == 1 && stickerItems?.length == sticker?.sticker_items_limit) {
                      history.push(`/stickers/${stickerId}/${stickerItems?.[0]?.id}`)
                  }
                  dispatch(setScanCongratulationsVisibility(false));
                  dispatch(stickerShowCongratulation(false));
              }}
              showAnimation={sticker?.type === "GREETING"}
              isMemorialTheme={ isStickerTypeMemorial }
            />
          </Fragment>
        )
    }

    const onAddItemClick = () => {
        history.push(`/stickers/${stickerId}/new`)
    }

    return <Fragment>
        {/*
             // @ts-ignore */}
        <StickersComponentsScannerHeader theme={ isStickerTypeMemorial ? 'white' : 'brand' }
                                         title={t(isStickerTypeMemorial ? "headerTitleMemorial" : "headerTitle")}
                                         showBackBtn={false}
        />
        <Div100vh className={ isStickerTypeMemorial ? styles.scrollView_memorial : styles.scrollView }>
            <div className={styles.header}>
                <div className={`${ isStickerTypeMemorial ? styles.title_memorial : styles.title } font-title`}
                     dangerouslySetInnerHTML={{__html: t(isStickerTypeMemorial ? "titleMemorial" : "title")}}/>
                <div className={styles.stickerItemsPreview}>
                    {
                        sticker?.stickerItems
                        && sticker.stickerItems.map(id => <StickerItemPreviewItem key={id} stickerItemId={id}/>)
                    }
                </div>
            </div>
            <div className={styles.stickerInfo}>
                <div className={styles.scansCounterContainer}>
                    <Icon name="CounterEye" width="16px" height="9px" className={styles.scansCounterIcon}/>
                    <div
                        className={styles.scansCounterText}>{` ${sticker?.scans_count || '0'} ${t('views')}`}</div>
                </div>
                {canAddStickerItem &&
                <UQButton label={t('addButton')}
                          containerStyle={{}}
                          theme={ isStickerTypeMemorial ? 'memorial' : 'white' }
                          onPress={onAddItemClick}/>}
            </div>
            <Grid>
                {
                    sticker?.stickerItems
                    && sticker.stickerItems.map(id => <StickerItemGridItem key={id} stickerItemId={id}/>)
                }
            </Grid>
        </Div100vh>
    </Fragment>
}





// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/screens/sticker-show/index.tsx